import { useWritingStylesContext } from '@/contexts/WritingStylesContext';
import type { PersonalWritingStyle, BrandProfile } from '@/types';

export type WritingStyleItem =
  | (PersonalWritingStyle & { profileType: 'personal' })
  | (BrandProfile & { profileType: 'brand' });

interface UseWritingStylesReturn {
  // Data
  personalStyles: PersonalWritingStyle[];
  brandProfiles: BrandProfile[];
  allItems: WritingStyleItem[];
  totalCount: number;
  
  // Loading state
  loading: boolean;
  
  // Actions
  loadStyles: () => Promise<void>;
  deleteStyle: (id: string, type: 'personal' | 'brand') => Promise<void>;
  
  // Filtering
  getFilteredItems: (filter: 'all' | 'personal' | 'brands') => WritingStyleItem[];
}

/**
 * Hook for managing writing styles and brand profiles
 * Now uses WritingStylesContext for data management
 * 
 * @deprecated This hook is a wrapper around useWritingStylesContext for backward compatibility
 * Consider using useWritingStylesContext directly in new code
 */
export function useWritingStyles(): UseWritingStylesReturn {
  const context = useWritingStylesContext();

  return {
    personalStyles: context.personalStyles,
    brandProfiles: context.brandProfiles,
    allItems: context.allItems,
    totalCount: context.totalCount,
    loading: context.loading,
    loadStyles: context.loadStyles,
    deleteStyle: context.deleteStyle,
    getFilteredItems: context.getFilteredItems,
  };
}
